export default "/images/aec863431faa73f0bcbbaf7df4a9d705.avif";